import Papa from 'papaparse';

const MARKER = '__dutilyne_report__';
const ERROR = '__dutilyne_error__';
const SOURCE_ROW = '__dutilyne_source_row__';
const META = new Set([MARKER, ERROR, SOURCE_ROW]);
// Escape spreadsheet formulas AND literal leading apostrophes, reversibly.
const safeCell = (v) => /^[=+\-@\t\r']/.test(String(v ?? '')) ? `'${v}` : String(v ?? '');
const originalCell = (v) => /^'[=+\-@\t\r']/.test(String(v ?? '')) ? String(v).slice(1) : v;
const safeHeader = (h) => META.has(h) ? `'${h}` : safeCell(h);
const originalHeader = (h) => h.startsWith("'") && META.has(h.slice(1)) ? h.slice(1) : originalCell(h);

export function readImportRows(parsed) {
  const headers = parsed.meta.fields || [];
  const rows = parsed.data || [];
  const isReport = [MARKER, ERROR, SOURCE_ROW].every(h => headers.includes(h)) && rows.every(r => r[MARKER] === 'v1');
  if (!isReport) return { headers, rows };
  const sourceHeaders = headers.filter(h => !META.has(h));
  return {
    headers: sourceHeaders.map(originalHeader),
    rows: rows.map(row => Object.fromEntries(sourceHeaders.map(h => [originalHeader(h), originalCell(row[h])]))),
  };
}

export function downloadFailedRows(headers, rows, failures, filename) {
  if (!failures?.length) return;
  // Source rows, not normalised data: invalid values remain available to fix.
  const data = [headers.map(safeHeader).concat([ERROR, SOURCE_ROW, MARKER])];
  const seen = new Set();
  failures.forEach(failure => {
    const row = rows[failure.row - 2];
    if (!row || seen.has(failure.row)) return;
    seen.add(failure.row);
    data.push(headers.map(h => safeCell(row[h])).concat([
      safeCell(failure.errors.join('; ')), String(failure.row), 'v1',
    ]));
  });
  const blob = new Blob(['\uFEFF', Papa.unparse(data)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${(filename || 'catalog').replace(/\.csv$/i, '')}-failed-rows.csv`;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}